// Layers header IDs
export const ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
export const ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
export const ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
export const ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE =
  'TransportsFiltersMobileLayerHeaderId';
export const ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
export const ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
export const ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
export const ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
export const ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
export const ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
export const ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
export const ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
export const ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
export const ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
export const ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
export const ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
export const ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
export const ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
export const ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId';

// Modals header IDs
export const ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
export const ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
export const ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
export const ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION =
  'SaveCriteriaConfirmationModalHeaderId';
export const ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
export const ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
export const ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
export const ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
export const ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
export const ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
export const ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
export const ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
export const ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
export const ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';
